import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetFacilityOccupancyForecastRequestDtoSchema = z.object({
  facilityId: z.string(),
  from: z.string(),
  to: z.string(),
});

const GetFacilityOccupancyForecastResponseDtoSchema = z.object({
  actuals: z.array(
    z.object({
      month: z.string(),
      value: z.number(),
    })
  ),
  forecast: z.array(
    z.object({
      month: z.string(),
      value: z.number(),
    })
  ),
});

export type GetFacilityOccupancyForecastRequestDto = z.infer<
  typeof _GetFacilityOccupancyForecastRequestDtoSchema
>;

export type GetFacilityOccupancyForecastResponseDto = z.infer<
  typeof GetFacilityOccupancyForecastResponseDtoSchema
>;

export const getFacilityOccupancyForecast = (
  params: GetFacilityOccupancyForecastRequestDto,
  config: AxiosRequestConfig<GetFacilityOccupancyForecastRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`facilities/${facilityId}/occupancy-forecast`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetFacilityOccupancyForecastResponseDtoSchema));
};
